import React, { useEffect, useState } from "react";
import { Button, Checkbox, Col, Form, Input, Row, Select, Table, Radio, notification, Typography, message } from "antd";
import { CiSquarePlus } from "react-icons/ci";
import { DeleteOutlined, } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { containerService, customerService, destinationService, quotationService, shippingLineService, vehicleService, } from "../../../services";
import { v4 as uuidv4 } from "uuid";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";
import MaterialLikeDatePicker from "../../../components/MaterialLikeDatePicker";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import dayjs from "dayjs";
import { changeDocumentTitle } from "../../../utils/title";

const { Title } = Typography

export default function QuotationForm() {
  const { id } = useParams(); // Get 'id' from the URL
  const navigate = useNavigate();
  const [quotations, setQuotations] = useState({
    details: [],
  });
  const [customers, setCustomers] = useState([]);
  const [selectedValue, setSelectedValue] = useState(2);
  const [destinations, setDestinations] = useState([]);
  const [shippingLine, setShippingLine] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [containerSizes, setContainerSizes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const isEditMode = id !== undefined;

  const columns = [
    {
      title: "Id",
      dataIndex: "uuid",
      key: "Id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Shipping Line",
      dataIndex: "shipping_line_id",
      key: "ShippingLine",
      width: 200,
      render: (text, record, index) => (
        <Select
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(value) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].shipping_line_id = value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        >
          {shippingLine.map((shippingLine) => (
            <Select.Option key={shippingLine.id} value={shippingLine.id}>
              {shippingLine.name}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "Destination",
      width: 200,
      render: (text, record, index) => (
        <Select
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(value) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].destination_id = value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        >
          {destinations.map((destination) => (
            <Select.Option key={destination.id} value={destination.id}>
              {destination.name}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Container Size",
      dataIndex: "containersize_id",
      key: "ContainerSize",
      width: 200,
      render: (text, record, index) => (
        <Select
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(value) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].containersize_id = value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        >
          {containerSizes.map((containerSizes) => (
            <Select.Option key={containerSizes.id} value={containerSizes.id}>
              {containerSizes.name}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Fright Charges",
      dataIndex: "charges",
      key: "FrightCharges",
      width: 200,
      render: (text, record, index) => (
        <Input
          value={text || ""}
          onChange={(e) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].charges = e.target.value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
          style={{ width: "100%" }}
        />
      ),
    },
    {
      title: "No Of Vehicles",
      dataIndex: "no_of_vehicles",
      key: "NoOfVehicles",
      width: 200,
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].no_of_vehicles = e.target.value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        />
      ),
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicle_type",
      key: "Vehicle Type",
      width: 200,
      render: (text, record, index) => (
        <Select
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(value) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].vehicle_type = value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        >
          {vehicleTypes.map((vehicletype) => (
            <Select.Option key={vehicletype} value={vehicletype}>
              {vehicletype}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Loading Charges",
      dataIndex: "loading_charges",
      key: "LoadingCharges",
      width: 200,
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].loading_charges = e.target.value;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        />
      ),
    },
    {
      title: "Is DG",
      dataIndex: "is_dg",
      key: "Is DG",
      render: (text, record, index) => (
        <Checkbox
          defaultChecked={text}
          onChange={(e) => {
            const updatedDetails = [...quotations.details];
            updatedDetails[index].is_dg = e.target.checked ? 1 : 0;
            setQuotations((prev) => ({ ...prev, details: updatedDetails }));
          }}
        />
      ),
    },
    {
      title: (
        <div>
          <DeleteOutlined style={{ fontSize: "18px" }} />
        </div>
      ),
      key: "Delete",
      render: (text, record, index) => {
        if (quotations.details.length === 1) return null;
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => handleDeleteRow(record.id)}
          >
            <DeleteOutlined />
          </Button>
        );
      },
    },
  ];

  const handleAddRow = () => {
    setQuotations((prev) => ({
      ...prev,
      details: [
        ...(prev?.details || []),
        {
          id: uuidv4(),
          shipping_line_id: null,
          destination_id: null,
          containersize_id: null,
          vehicle_type: null,
          charges: "",
          no_of_vehicles: "",
          loading_charges: "",
          is_dg: false,
        },
      ],
    }));
  };

  const handleDeleteRow = (Id) => {
    setQuotations((prev) => {
      const updatedDetails = (prev?.details || []).filter((item) => item.id !== Id);

      return {
        ...prev,
        details: updatedDetails,
      };
    });
  };


  const getCustomers = async () => {
    const { success, data } = await customerService.fetchCustomers();
    if (success) {
      setCustomers(data);
    }
  };

  const getDestinations = async () => {
    const { success, data } = await destinationService.fetchDestination();
    if (success) {
      setDestinations(data);
    }
  };

  const getShippingLine = async () => {
    const { success, data } = await shippingLineService.fetch();
    if (success) {
      setShippingLine(data);
    }
  };

  const getVehicleType = async () => {
    const { success, data } = await vehicleService.getTypes();
    if (success) {
      setVehicleTypes(data);
    }
  };

  const getContainerSize = async () => {
    const { success, data } = await containerService.fetchsizes();
    if (success) {
      setContainerSizes(data);
    }
  };

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
    form.setFieldsValue({
      paymentcollectiontype: e.target.value,
    });
  };

  const onFinish = async (values) => {
    setLoading(true);
    const shippingLineIds = quotations.details.map((detail) => detail.shipping_line_id).filter((id) => id);
    const destinationIds = quotations.details.map((detail) => detail.destination_id).filter((id) => id);
    const containerIds = quotations.details.map((detail) => detail.containersize_id).filter((id) => id);

    const vehicleTypesArray = quotations.details.map((detail) => detail.vehicle_type);

    if (!shippingLineIds.length || !destinationIds.length || !containerIds.length || !vehicleTypesArray.some((type) => type)) {
      setLoading(false)
      return message.error('Validation failed. Please add freight container charges');
    }


    const freightChargesArray = quotations.details.map((detail) => detail.charges || 0);

    const noOfVehiclesArray = quotations.details.map((detail) => detail.no_of_vehicles);

    const loadingChargesArray = quotations.details.map((detail) => detail.loading_charges);

    const isDGArray = quotations.details.map((detail) => detail.is_dg);

    const payload = {
      ...values,
      date: dayjs(values.date).format("YYYY-MM-DD"),
      validity: dayjs(values.validity).format("YYYY-MM-DD"),
      paymentType: selectedValue,
      shippingline: shippingLineIds,
      destination: destinationIds,
      vehicle_type: vehicleTypesArray,
      container: containerIds,
      freight_charges: freightChargesArray,
      no_of_vehicles: noOfVehiclesArray,
      load_charges: loadingChargesArray,
      is_dg: isDGArray,
    };

    const response = isEditMode ? await quotationService.editQuotation(id, payload) : await quotationService.addQuotation(payload);
    setLoading(false);

    if (response?.success ?? false) {
      notification.success({ message: "Success", description: `Quotation ${isEditMode ? 'updated' : 'added'} successfully!`, placement: "topRight" });
      navigate(`/operations/quotation`)
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }
  };

  const initialize = async () => {
    if (isEditMode) {
      const hide = message.loading("Fetching Data...", 0)
      const { success, data } = await quotationService.view(id)
      hide()
      if (success) {
        const updatedData = {
          ...data,
          details: data.details.map((detail) => ({
            ...detail,
            uuid: uuidv4(),
          })),
        };
        setQuotations(updatedData);
        setSelectedValue(data.userQuotation.payment_collection_type_id);
        form.setFieldsValue({
          ...data.userQuotation,
          paymentType:
            data.userQuotation.payment_collection_type_id,
          date: dayjs(data.userQuotation.date),
          validity: dayjs(data.userQuotation.validity_date),
          chasis_days: data.details[0].chasis_days,
          chasis_charges: data.details[0].chasis_charges,
          storage_charges: data.details[0].storage_charges,
          storage_days: data.details[0].storage_days,
        });
      }
    } else {
      handleAddRow()
    }
  };

  useEffect(() => {
    changeDocumentTitle(isEditMode ? " Edit Quotation" : " Add Quotation");
    initialize();
    getCustomers();
    getDestinations();
    getShippingLine();
    getVehicleType();
    getContainerSize();
  }, []);

  return (
    <div
      style={{
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ paymentType: 2 }}
      >
        <Row gutter={24}>
          <Col span={24}>
            <h1 style={{ fontWeight: "bold" }} className="pt-2  pb-5">
              {" "}
              {isEditMode ? "Edit Quotation" : "Add Quotation "}
            </h1>
          </Col>
          <Col span={6}>
            <Form.Item
              name="user_id"
              rules={[
                {
                  required: true,
                  message: "Please select a customer!",
                }
              ]}
            >
              <MaterialLikeSelect
                label="Customer"
                required
                value={form.getFieldValue("user_id")}
                onChange={(value) => form.setFieldValue('user_id', value)}
                options={customers.map((customer) => ({
                  id: customer.id,
                  value: customer.id,
                  label: customer.name,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="date" rules={[{ required: true, message: "Please select quotation date!" }]}>
              <MaterialLikeDatePicker
                required
                label="Quotation Date"
                value={form.getFieldValue("date")}
                onChange={(date) => form.setFieldValue("date", date)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="validity" rules={[{ required: true, message: "Please select valid date!" }]}>
              <MaterialLikeDatePicker
                required
                label="Valid Date"
                value={form.getFieldValue("validity")}
                onChange={(date) => form.setFieldValue("validity", date)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="chasis_days" rules={[{ required: true, message: "Please input chassis days!" }]}>
              <MaterialLikeInput
                required
                label="Chassis Days"
                value={form.getFieldValue("chasis_days")}
                onChange={(e) => form.setFieldValue("chasis_days", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="chasis_charges" rules={[{ required: true, message: "Please input chassis charges!" }]}>
              <MaterialLikeInput
                label="Chassis Charges"
                value={form.getFieldValue("chasis_charges")}
                onChange={(e) => form.setFieldValue("chasis_charges", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="storage_charges" rules={[{ required: true, message: "Please input storage charges!" }]}>
              <MaterialLikeInput
                label="Storage Charges"
                value={form.getFieldValue("storage_charges")}
                onChange={(e) => form.setFieldValue("storage_charges", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="storage_days" rules={[{ required: true, message: "Please input storage days!" }]}>
              <MaterialLikeInput
                label="Free Storage Days"
                value={form.getFieldValue("storage_days")}
                onChange={(e) => form.setFieldValue("storage_days", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="payment_days" rules={[{ required: true, message: "Please input payment days!" }]}>
              <MaterialLikeInput
                label="Payment Day"
                value={form.getFieldValue("payment_days")}
                onChange={(e) => form.setFieldValue("payment_days", e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginTop: "10px" }}>
          <Col span={24}>
            <p>Payment Collection Type</p>
          </Col>
          <Col span={4}>
            <Form.Item name="paymentType">
              <Radio.Group
                value={selectedValue}
                onChange={handleRadioChange}
                className="flex flex-row gap-4 justify-center items-center w-[200px]"
              >
                <Radio value={1}>ETA</Radio>
                <Radio value={2}>Invoice Terms</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <div
          style={{
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            margin: 40,
            marginTop: 10,
          }}
        >
          {/* {isTableVisible && ( */}
          <Table
            title={() => <Title level={5}><span style={{ color: 'red' }}>*</span> Add Freight Container Charges</Title>}
            columns={columns}
            scroll={{ x: "max-content" }}
            dataSource={quotations.details}
            pagination={false}
            rowKey="Id"
            style={{ marginTop: "10px" }}
          />
          {/* )} */}
          <div
            style={{ marginTop: 5 }}
            className="flex flex-col justify-center items-center"
          >
            <CiSquarePlus
              style={{ cursor: "pointer", fontSize: "25px" }}
              onClick={handleAddRow}
            />
          </div>
        </div>
        <Form.Item style={{ textAlign: "center", marginTop: 30 }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "50%" }}
            loading={loading}
          >
            {" "}
            {isEditMode ? "EDIT QUOTATION" : "ADD QUOTATION "}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}